<template>
  <!-- 党的建设查看更多二级页 -->
  <div>
    <div class="dsxxpage-content">
      <!--面包屑-->
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>党的建设</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="dsxqy-cont">
        <div style="margin-top: 30px">
          <el-tabs v-model="activeName" @tab-click="handleTabClick">
            <el-tab-pane v-for="item in list" :key="item.id">
              <span slot="label">{{ item.columnName }}</span>
            </el-tab-pane>
          </el-tabs>
          <div class="dsxqy-cont-down">
            <span class="title">最新关注</span>
            <!-- <div v-loading="gzLoading" :class="{'list-container':gzLoading}"> -->
              <el-empty description="暂无数据" v-if="!data || !data.length"></el-empty>
              <ul v-else>
                <li v-for="(item, index) in data" :key="index">
                  <a :href="item.linkUrl" target="_blank">{{ item.buildTitle }}<template v-if="item.buildSubTitle">——</template>{{ item.buildSubTitle }}</a>
                  <span>{{ item.buildPubTime }}</span>
                </li>
              </ul>
            <!-- </div> -->
          </div>
          <div class="block">
            <el-pagination
              background
              @size-change="gzHandleSizeChange"
              @current-change="gzHandleCurrentChange"
              :current-page="pageNum"
              :page-size="pageSize"
              layout="total, prev, pager, next, jumper"
              :total="gzTotal"
            >
            </el-pagination>
          </div>
          <div class="dsxqy-cont-down">
            <span class="title">最新研究</span>
            <div v-loading="loading" :class="{'list-container':loading}">
              <el-empty description="暂无数据" v-if="!loading && (!yjData || !yjData.length)"></el-empty>
              <ul v-else>
                <li v-for="(item, index) in yjData" :key="index">
                  <a :href="item.nodeUrl" target="_blank" :title="item.title">{{ item.title }}</a>
                  <span>{{ item.pubDate.substring(0,10) }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!--分页-->
      <div class="block">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="toTal"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { partyBuildingMixin } from "../mixins/mixin";
export default {
  mixins: [partyBuildingMixin],
  data() {
    return {
      constructList: [],
      currentPage: 1,
      pageSize: 10,
      toTal: 0,
      yjList:[],
      yjUidList:[],
      yjData:[],
      gzTotal:0,
      loading:false,
    };
  },
  created(){
    this.getYJList()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
    },
    gzHandleSizeChange(val) {
      this.pageNum = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getYJPartyBuildingData()
    },
    gzHandleCurrentChange(val) {
      this.pageNum = val;
      this.getPartyBuildingData()
    },
    handleTabClick(){
      this.yjData = []
      this.toTal = 0
      this.gzTotal = 0
      this.data = []
      this.currentPage = 1
      this.pageNum = 1
      this.getPartyBuildingData()
      this.getYJPartyBuildingData()
    },
    getYJList(){
      this.axios.get("data/custom/classType?uid=32614a21-81e2-4b40-a38f-d3aa6dffe529&pageNum=1&pageSize=10").then((res) => {
        if (res.status == 200) {
          this.yjList = res.data.rows;
          this.yjUidList = this.yjList.map(item => item.uid)
          this.getYJPartyBuildingData()
        } else {
          this.$message.error("获取失败！");
        }
      });
    },
    getYJPartyBuildingData() {
      this.loading = true
      this.axios.post("data/cnki/getKbaseList",{
        uid: this.yjUidList[Number(this.activeName)],
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        sign:'更多'
      }).then((res) => {
        if (res.status == 200) {
          this.loading = false
          this.yjData = res.data.rows;
          this.toTal = res.data.total
        } else {
          this.$message.error("获取失败！");
        }
      });
    },
  },
};
</script>

<style  lang="scss" scoped>
::v-deep {
  .el-tabs__nav-wrap::after {
    display: none;
  }

  .el-tabs__active-bar {
    display: none;
  }

  .el-tabs__item {
    margin-right: 10px;
    width: 162px;
    height: 70px;
    text-align: center;
    line-height: 70px;
    color: #f9fdcc;
    font-size: 18px;
    font-weight: 700;
    padding: 0 !important;
    background: url("../assets/images/collapse/ddjs-tab1.png");
    &:hover,&.is-active{
      background: url("../assets/images/collapse/ddjs-tab1_hover.png");
    }
    &:nth-child(2) {
      background: url("../assets/images/collapse/ddjs-tab2.png");
      &:hover,&.is-active{
        background: url("../assets/images/collapse/ddjs-tab2_hover.png");
      }
    }
    &:nth-child(3) {
      background: url("../assets/images/collapse/ddjs-tab3.png");
      &:hover,&.is-active{
        background: url("../assets/images/collapse/ddjs-tab3_hover.png");
      }
    }
    &:nth-child(4) {
      background: url("../assets/images/collapse/ddjs-tab4.png");
      &:hover,&.is-active{
        background: url("../assets/images/collapse/ddjs-tab4_hover.png");
      }
    }
    &:nth-child(5) {
      background: url("../assets/images/collapse/ddjs-tab5.png");
      &:hover,&.is-active{
        background: url("../assets/images/collapse/ddjs-tab5_hover.png");
      }
    }
    &:nth-child(6) {
      background: url("../assets/images/collapse/ddjs-tab6.png");
      &:hover,&.is-active{
        background: url("../assets/images/collapse/ddjs-tab6_hover.png");
      }
    }
    &:last-child {
      margin-right: 0;
      background: url("../assets/images/collapse/ddjs-tab7.png");
      &:hover,&.is-active{
        background: url("../assets/images/collapse/ddjs-tab7_hover.png");
      }
    }
  }
}
.list-container{
  min-height: 110px;
}
.dsxxpage-content {
  width: 1200px;
  height: auto;
  margin: 30px auto;
  margin-bottom: 70px;
  .breadcrumb {
    position: relative;
    box-sizing: border-box;
    padding-left: 20px;
    .el-breadcrumb {
      font-size: 16px;
    }
  }
  .breadcrumb:before {
    content: "";
    position: absolute;
    left: 0;
    display: inline-block;
    width: 17px;
    height: 16px;
    background: url("../assets/images/dzdgpage_arr.png") no-repeat;
  }
  .dsxxpage-cont {
    position: relative;
    height: auto;
    margin-top: 20px;
  }
  .dsxqy-cont {
    .dsxqy-cont-down {
      width: 1200px;
      margin: 15px 0 50px;
      box-sizing: border-box;
      padding: 16px 30px 0 30px;
      background: url("../assets/images/dnhd-dwbg.png") repeat-x;
      .title{
        display: block;
        font-size: 20px;
        font-weight: bold;
        color: #de1c26;
        margin-bottom: 5px
      }
      li {
        position: relative;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        line-height: 40px;
        a {
          margin-left: 18px;
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: calc(100% - 141px);
          &:hover{
            color: #BD1A2D;
          }
        }
      }
      li:before {
        position: absolute;
        top: 14px;
        content: "";
        display: inline-block;
        width: 8px;
        height: 12px;
        background: url("../assets/images/vector.png") no-repeat;
      }
      p {
        text-align: right;
        font-size: 16px;
        margin-top: 10px;
        a {
          color: #9f9fa6;
        }
      }
    }
  }
   :deep(.block) {
    margin-top: 40px;
    text-align: center;
  }
}
</style>